import { gql } from '@apollo/client';

const CREATE_RESET_PASSWORD_REQUEST_MUTATION = gql`
  mutation CreateResetPasswordRequestMutation($email: String!) {
    createUserResetPasswordRequest(email: $email) {
      id
      model_id
    }
  }
`;

export default CREATE_RESET_PASSWORD_REQUEST_MUTATION;
